import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-projects10',
  templateUrl: './section-projects10.component.html',
  styleUrls: ['./section-projects10.component.css']
})
export class SectionProjects10Component implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit(): void {
  }

}
